lmApp
  .service('ManageEPGChannelsWindow', ['$rootScope', '$q', '$templateCache', '$compile', '$filter', 'ModalWindowService', 'ToastService',
    function ($rootScope, $q, $templateCache, $compile, $filter, ModalWindowService, ToastService) {
      var service = {};

      service.Open = function (options) {
        var windowScope = $rootScope.$new();

        windowScope.loading = false;
        windowScope.fullscreen = false;
        windowScope.keyword = '';
        windowScope.filters = {};
        windowScope.offset = 0;
        windowScope.limit = 20;

        windowScope.searchResult = [];
        windowScope.title = options.title;
        windowScope.collection = options.collection || [];
        windowScope.currentCollection = options.currentCollection || [];

        windowScope.$watch('filters', function (newValue, oldValue) {
          if (oldValue && !_.isEmpty(newValue)) {
            windowScope.applyFilters(newValue);
          }
        });

        windowScope.nextPage = function () {
          if ((windowScope.offset + windowScope.limit) >= windowScope.collection.length) {
              return
          }
          windowScope.offset += windowScope.limit;
        };

        windowScope.prevPage = function () {
          if (windowScope.offset >= windowScope.limit) {
            windowScope.offset -= windowScope.limit;
          } else {
            windowScope.offset = 0;
          }
        };

        windowScope.applyFilters = function (filters) {
          filters.keyword = _.trim(filters.keyword);
          windowScope.searchResult = $filter('filter')(windowScope.collection, filters.keyword);
        };

        windowScope.manageChannels = {
          add: [],
          remove: []
        };

        windowScope.close = function () {
          if (windowScope.loading) return;
          windowScope.fullscreenToggle(false);
          ModalWindowService.Close(windowScope.window, false);
        };

        windowScope.fullscreenToggle = function (state) {
          if (typeof state !== 'undefined') {
            windowScope.fullscreen = state;
          } else {
            windowScope.fullscreen = !windowScope.fullscreen;
          }
          ModalWindowService.Fullscreen(windowScope.window, state);
        };

        windowScope.addChannelTo = function (channel) {
          channel._PrivateData.inCurrent = true;

          windowScope.manageChannels.remove.forEach(function (item, index, collection) {
            if (item.id === channel.id) {
              collection.splice(index, 1);
            }
          });

          var item = _.find(windowScope.manageChannels.add, {id: channel.id});
          if (!item) windowScope.manageChannels.add.push(channel);
        };

        windowScope.removeChannelFrom = function (channel) {
          channel._PrivateData.inCurrent = false;

          windowScope.manageChannels.add.forEach(function (item, index, collection) {
            if (item.id === channel.id) {
              collection.splice(index, 1);
            }
          });

          var item = _.find(windowScope.manageChannels.remove, {id: channel.id});
          if (!item) windowScope.manageChannels.remove.push(channel);
        };

        windowScope.manageChannelsFor = function () {
          $rootScope.showLinearProgress('#mgmtWindowLoader');
          windowScope.loading = true;

          var allQ = options.manageChannelsFn(windowScope.manageChannels.add, windowScope.manageChannels.remove, options.obj);

          $q.all(allQ)
            .then(function () {
              $rootScope.hideLinearProgress('#mgmtWindowLoader');
              windowScope.loading = false;
              ToastService.Small({
                title: 'EPG channels added/removed. Don\'t forget to save changes',
                color: 'green',
                icon: 'package-down'
              }, 1000 * 3);
              windowScope.close();
            })
            .catch(function (reason) {
              ToastService.Small({
                title: 'Error happened. Try again',
                color: 'red',
                icon: 'package-down'
              }, 1000 * 3);
              $rootScope.debugInfo(reason);
              $rootScope.hideLinearProgress('#mgmtWindowLoader');
              windowScope.loading = false;
            });
        };


        windowScope.$watch('searchResult', function (newValue, oldValue) {
          windowScope.searchResult.forEach(function (channel) {
            if (!channel._PrivateData) channel._PrivateData = {};
            channel._PrivateData.inCurrent = _.includes(windowScope.currentCollection, channel.id);
            return channel;
          });
        });

        windowScope.selectAll = function () {
          if (!windowScope.isSelectedAll()) {
            windowScope.searchResult.forEach(function (channel) {
              windowScope.addChannelTo(channel);
            });
          } else {
            windowScope.searchResult.forEach(function (channel) {
              windowScope.removeChannelFrom(channel);
            });
          }
        };

        windowScope.isSelectedAll = function () {
          return windowScope.searchResult.filter(function (channel) {
              return channel._PrivateData.inCurrent;
            }).length === windowScope.searchResult.length;
        };

        windowScope._modalWindow_ = $templateCache.get('lm-manage-epg-channels-window/lm-manage-window.tpl.html');
        windowScope._modalWindow_ = $compile(windowScope._modalWindow_)(windowScope);

        windowScope.window = ModalWindowService.Open({
          content: windowScope._modalWindow_,
          navigation: $compile($templateCache.get('lm-manage-epg-channels-window/lm-manage-window-nav.tpl.html'))(windowScope),
          clear: true,
          keyboard: true,
          size: {
            s: 11,
            l: 10
          },
          onComplete: function () {
            windowScope.$destroy();
          }
        });

        windowScope.applyFilters({keyword: ''});
      };

      return service;
    }]);
